module.exports = __webpack_public_path__ + "img/map_Z3.5.B.04.5d6886e8.svg";